import { instance } from "api/apiBase";

interface ZillowStatusResponse {
  connected: boolean;
}

const BASE_ENDPOINT_URL = "/portal/v1/external_integrations/zillow";

export const zillowApi = {
  getStatus: async (): Promise<ZillowStatusResponse> => {
    const { data } =
      await instance.get<ZillowStatusResponse>(BASE_ENDPOINT_URL);
    return data;
  },

  connect: async (): Promise<ZillowStatusResponse> => {
    const { data } =
      await instance.post<ZillowStatusResponse>(BASE_ENDPOINT_URL);
    return data;
  },

  disconnect: async (): Promise<ZillowStatusResponse> => {
    const { data } =
      await instance.delete<ZillowStatusResponse>(BASE_ENDPOINT_URL);
    return data;
  }
};
